import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68778acf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "em-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "end-info-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "活动已结束")
], -1))
const _hoisted_4 = { class: "message-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "提示", -1))
const _hoisted_6 = { class: "tips" }

import { ref, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getXaShortLink } from '@/apis/public'
import { commonErrorHandle } from '@/utils/error-handle'
import { useCommonShare } from '@/compositions/activity/index'
import { clearToast, showToastLoading } from '@/utils/tools'
import Header from '@/components/Header.vue'
import CheckBindSn from './components/check-bind-sn.vue'
import ShareContent from './components/share-content.vue'
import ActivityDialog from './components/activity-dialog.vue'
import ActivityIntroduceImage from './components/activity-introduce-image.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'old-user',
  setup(__props) {

const store = useStore()
const showShareContent = ref(false)
const qrcodeUrl = ref('')
const router = useRouter()
const activeEndDialogShow = ref(false)
const tipsDialogShow = ref(false)
const isNewUser = ref(store?.state?.OldBringsNew?.isNewUser || false)
const inviteCode = ref(store?.state?.OldBringsNew?.inviteCode || '')
const expiredMessage = '当前不在活动有效期，欢迎关注【极飞科技】公众号，关注后续活动信息。'
const unOldUserMessage = '您当前不满足老客户条件，具体条件可查看活动简介。'
const tipsContent = ref(expiredMessage)
const { getShareUrlInfo } = useCommonShare()

function sleep() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(1)
    }, 1000)
  })
}
function showUnOldUserTip() {
  tipsContent.value = unOldUserMessage
  tipsDialogShow.value = true
}
async function startReferralHandle() {
  if (isNewUser.value) {
    showUnOldUserTip()
    return
  }
  // 生成
  showToastLoading()
  try {
    const { inviteNewUserUrl } = getShareUrlInfo({
      code: inviteCode.value,
    })
    const res = await getXaShortLink({
      url: inviteNewUserUrl,
    })
    qrcodeUrl.value = `https://s.xa.com/mini?k=${res.key}`
  } catch (error) {
    commonErrorHandle(error)
  }
  clearToast()
  showShareContent.value = true
}
function goToClaim() {
  if (isNewUser.value) {
    showUnOldUserTip()
    return
  }
  router.push({ name: 'activity-old-bring-new-claim-page' })
}

async function pageInit() {
  if (isNewUser.value) {
    showUnOldUserTip()
  }
}

pageInit()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, {
      title: "邀请好友，奖励赚不停",
      rightUseSlot: ""
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ActivityIntroduceImage)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "footer-wrap" }, [
        _createElementVNode("div", {
          class: "referral-rewards-button btn",
          onClick: startReferralHandle
        }),
        _createElementVNode("div", {
          class: "progress-claim-button btn",
          onClick: goToClaim
        })
      ]),
      _createVNode(CheckBindSn)
    ]),
    _createVNode(ShareContent, {
      code: inviteCode.value,
      show: showShareContent.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showShareContent).value = $event)),
      qrcodeUrl: qrcodeUrl.value
    }, null, 8, ["code", "show", "qrcodeUrl"]),
    _createVNode(ActivityDialog, {
      show: activeEndDialogShow.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((activeEndDialogShow).value = $event)),
      type: 0
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(ActivityDialog, {
      show: tipsDialogShow.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((tipsDialogShow).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(tipsContent.value), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})